/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Abdul Mohiz",
  title: "Hi all, I'm Mohiz",
  subTitle: emoji(
    "A passionate Software Engineer 🚀 with a proven track record in leading teams and developing innovative web and mobile solutions."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1zWhL37IpZUnx16mlRw8OgtGHTEPZa0NM/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/AbdulMohiz",
  linkedin: "https://www.linkedin.com/in/abdul-mohiz-200578134/",
  gmail: "abdul.mohizi97@gmail.com",
  gitlab: "https://gitlab.com/abdulmohiz",
  // facebook: "https://www.facebook.com/",
  // medium: "https://medium.com/",
  // stackoverflow: "https://stackoverflow.com/",
  // FInstagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "PASSIONATE FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive UI / Servers for your web and mobile applications"
    ),
    emoji("⚡ Single Page Applications ( SPA ) in normal and SSR/PWA Stacks"),
    emoji(
      "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "vuejs",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "scss",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "server",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "cloudflare",
      fontAwesomeClassname: "fab fa-cloudflare"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "jira",
      fontAwesomeClassname: "fab fa-jira"
    },
    {
      skillName: "github",
      fontAwesomeClassname: "fab fa-github"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Abbottabad University of Science and Technology",
      logo: require("./assets/images/aust.png"),
      subHeader: "Bachelors of Science in Computer Science",
      duration: "August 2015 - December 2019",
      desc: "Participated in the research of URDU Language Corpora.",
      descBullets: [
        "Managed, Participated and won multiple titles in iTech Society competitions",
        "Got multiple certifications in different technical skills"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "90%"
    },
    {
      Stack: "Database",
      progressPercentage: "80%"
    },
    {
      Stack: "AWS",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior Specialist Engineer",
      company: "Arçelik",
      companylogo: require("./assets/images/arcelik.png"),
      date: "June 2023 – Present",
      desc: "Started working as a senior specialist engineer at fortune 500.",
      descBullets: [
        "R&D islamabad",
        "TV APPS"
      ]
    },
    {
      role: "Sr. Full Stack Engineer",
      company: "Alagzoo",
      companylogo: require("./assets/images/alagzoo.jpeg"),
      date: "Nov 2021 – June 2023",
      desc: "As a Full Stack Developer at Alagzoo, I was responsible for designing, developing, and maintaining web applications using the MERN stack. I collaborate with cross-functional teams to deliver software solutions that meet business requirements and technical specifications. I write clean, efficient, and well-documented code, participate in code reviews and testing, and identify and solve technical problems to ensure high-quality software delivery.",
      descBullets: [
        "Team Lead",
        "SAAS"
      ]
    },
    {
      role: "Full Stack Engineer",
      company: "TeleTaleem",
      companylogo: require("./assets/images/teletaleem.jpg"),
      date: "Sep 2021 – Nov 2021",
      desc: "Developed and maintained various KPK government projects as a Full Stack Engineer at Teletaleem. Collaborated with cross-functional teams to design, implement, and deploy web applications with a strong focus on user experience. Utilized Google Maps API extensively to integrate location-based features and enhance the functionality of backend systems. Assisted in defining and optimizing backend architectures to improve performance, scalability, and reliability."
    },
    {
      role: "Front End Developer",
      company: "Financials Unlimited",
      companylogo: require("./assets/images/fu.jpeg"),
      date: "Oct 2020 – Nov 2021",
      desc: "As a Front End Developer at Financials Unlimited, I was responsible for developing and implementing user interface components using modern web development technologies, including React, Vue.js, React Native. I collaborated with back-end developers and UX/UI designers to ensure seamless integration of front-end and back-end functionalities. I wrote clean, efficient, and well-documented code, participate in code reviews and testing, and identied and solved technical problems to ensure high-quality software delivery."
    },
    {
      role: "Application Developer",
      company: "IIPS",
      companylogo: require("./assets/images/iips.jpeg"),
      date: "Sep 2018 – Oct 2020",
      desc: "Experienced Application Developer at IIPS, skilled in designing, developing, and maintaining software applications. Proven expertise in desktop and web apps. Committed to delivering high-quality solutions that meet business requirements while ensuring scalability, performance, and user experience. Passionate about innovation, collaboration, and staying up-to-date with emerging technologies. Contributing to the success of IIPS, driving the development of cutting-edge applications."
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/eyeSmarty.png"),
      projectName: "eyeSmarty",
      projectDesc: "Eye Smarty is used to monitor user's activity when working, also has plenty of features to chat, call and track down progress.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://eyesmarty.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/kpra.jpeg"),
      projectName: "KPRA",
      projectDesc: "KPRA is a Govt. project used for tax collection, plenty of features to manage pos and restaurants.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://kpra.gov.pk/"
        }
      ]
    },
    {
      image: require("./assets/images/sahneport.png"),
      projectName: "SahnePort",
      projectDesc: "Sahneport is a platform that offers comprehensive stage design and production services for events, including concerts, theater performances, and corporate gatherings.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.sahneport.com/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Trainer at Hazza by PSEB",
      subtitle:
        "Selected as a trainer to train volunteerly in different universities of twin cities, a project by Pakistan Software Export Board.",
      image: require("./assets/images/hazza.jpeg"),
      imageAlt: "Hazza Trainer Logo",
      footerLink: [
        {
          name: "Certification",
          url: ""
        },
        // {
        //   name: "Award Letter",
        //   url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        // },
        // {
        //   name: "Google Code-in Blog",
        //   url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        // }
      ]
    },
    {
      title: "Technical Director at SofTech Masters",
      subtitle:
        "Working as a technical director and managing all the teams.",
      image: require("./assets/images/stmasters.jpeg"),
      imageAlt: "SofTech Masters Logo",
      footerLink: [
        {
          name: "View Details",
          url: "https://stmasters.com/"
        }
      ]
    },
    {
      title: "Full Stack Development",
      subtitle: "Completed Certifcation from FrontEndMasters for Full Stack Development course",
      image: require("./assets/images/femasters.jpeg"),
      imageAlt: "Front End Masters Logo",
      footerLink: [
        {name: "Certification", url: ""},
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3135857489",
  email_address: "abdul.mohizi97@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
